export default {
  name: 'Pricing |||| Pricings',
  subtitle: 'Pricing plans keep financial configuration.',
  // Show
  tabs: {
    settings: 'Settings',
    perFeatures: 'Per Features',
    limits: 'Limits',
    fees: 'Fees',
    taxes: 'Taxes',
    loyalty: 'Loyalty',
  },
  feature: 'Feature',
  configuration: 'Configuration',
  statementTitle: 'Statement title',
  fields: {
    name: 'Name',
  },
  pnlAccount: "Tenant's Account",
  // Aside
  solution: 'Solution',
  product: 'Product',
  active: 'Active',
  kycLevels: 'KYC Levels',
  kycLevel: 'KYC Level',
  profileKycLevel: 'Profile KYC level',
  profileTags: 'Profile tags',
  paymentInstrument: 'Payment Instrument',
  pricingName: 'Name',
  // Settings
  pricingDetails: 'Pricing Details',
  activeFrom: 'Active from',
  activeTill: 'Active till',
  any: 'Any',
  editPricing: 'Edit Pricing Plan',
  deletePricing: 'Delete Pricing Plan',
  deletePricingWarning:
    'The pricing plan will be deleted permanently. This action cannot be undone.',
  // PerFeatures
  fee: 'Fee',
  service: 'Service charge',
  counter: 'Counter',
  limit: 'Limit',
  interest: 'Interest',
  editFee: 'Edit configuration',
  confirm: 'Confirm',
  // RegularFeeForm
  period: 'Period',
  annually: 'Annually',
  monthly: 'Monthly',
  type: 'Type',
  fixedFee: 'Fixed fee',
  tierBasedTurnover: 'Tier Based Turnover',
  tierBasedBalance: 'Tier Based Balance',
  billingDateType: 'Billing Date',
  fixed: 'Fixed',
  sliding: 'Sliding',
  billingDate: 'Billing Day',
  payOnTheFirstCalendarMonth: 'Pay on the first calendar month',
  // RegularFeeConfirmationField
  feeConfiguration: 'Fee configuration',
  amount: 'Amount',
  // FeeForm
  feeType: 'Fee type',
  currency: 'Currency',
  percent: 'Percent (%) |||| Percent',
  minAmount: 'Min amount',
  maxAmount: 'Max amount',
  minAmountOfPercentPart: 'Min amount (of % part)',
  maxAmountOfPercentPart: 'Max amount (of % part)',
  sender: 'Sender',
  recipient: 'Recipient',
  fixedDebitFee: 'Fixed Debit',
  tieredDebitFee: 'Tiered Debit',
  tieredCreditFee: 'Tiered Credit',
  percentDebitFee: 'Percent Debit',
  fixedCreditFee: 'Fixed Credit',
  percentCreditFee: 'Percent Credit',
  counterBasedDebitFee: 'Counter Based Debit',
  counterBasedCreditFee: 'Counter Based Credit',
  fixedPlusPercentDebitFee: 'Fixed+Percent Debit',
  fixedPlusPercentCreditFee: 'Fixed+Percent Credit',
  FIXED_INCREASE: 'Fixed Increase',
  FIXED_DECREASE: 'Fixed Decrease',
  PERCENT_INCREASE: 'Percent Increase Fee',
  PERCENT_DECREASE: 'Percent Decrease Fee',
  loyalty: 'Loyalty',
  loyalty_: {
    discountType: {
      _: 'Discount type',
      FULL: 'Full',
      PERCENT: 'Percent',
      FIXED: 'Fixed',
    },
    discountAmount: 'Discount amount',
    discountPercent: 'Discount percent',
    discountSourceAccount: 'Discount source account',
    loyaltySourceAccount: 'Loyalty source account',
    feeLoyaltyConfiguration: 'Fee Loyalty configuration',
    expiration: 'Expiration date',
  },
  limits: 'Limits',
  limits_: {
    amount: 'Amount',
    count: 'Count',
    countMustBePositive: 'Must be greater than 0',
  },
  limitConfiguration: 'Limit configuration',
  fork: 'Fork',
  forkHeading: 'Fork pricing position',
  cannotForkIncomplete: 'Configure this position before forking',
  tags: 'Transaction tags',
  index: 'Index (priority)',
  addNewTier: 'Add new tier',
  editTier: 'Edit tier',
  fixedPlusPercent: 'Fixed+Percent',
  add: 'Add',
  cancel: 'Cancel',
  tierStartsWith: 'Tier starts with',
  feeAlgorithm: 'Algorithm',
  tenTiersOnly: 'Up to %{maxTiers} tiers can be added',
  boundaryAlreadyExists: `Boundary of %{value} already exists`,
  tiers: 'Tiers',
  tax: 'Tax',
  taxConfiguration: 'Tax configuration',
  taxType: 'Tax type',
  addNewRule: 'Add new rule',
  defaultRule: 'Default rule',
  minTransferAmount: 'Min transfer amount',
  maxTransferAmount: 'Max transfer amount',
  minTransferAmountIncl: 'Min transfer amount (incl.)',
  maxTransferAmountExcl: 'Max transfer amount (excl.)',
  shouldIncreaseCounter: 'Should increase counter',
  yes: 'Yes',
  no: 'No',
  minCounterValue: 'Min counter value',
  maxCounterValue: 'Max counter value',
  minCounterValueIncl: 'Min counter value (incl.)',
  maxCounterValueExcl: 'Max counter value (excl.)',
  rules: 'Rules',
  rule: 'Rule %{num}',
  dynamicTypeCounterReference: 'Dynamic type counter reference',
  editDefaultRule: 'Edit default rule',
  editRule: 'Edit rule %{num}',
  minCounterMaxCounter: 'Min counter: %{min}, Max counter: %{max}',
  tenRulesOnly: 'Up to 10 rules can be added',
  earnings: 'Earnings',
};
